<app-reports
  title="Client Consult Note Reports"
  [reportsUrl]="reportsUrl" />
